<template>
  <div
    class="modal custom-modal fade modal-padding"
    id="addDataModal"
    role="dialog"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header header-border justify-content-between p-0">
          <h5 class="modal-title">Yeni layihə</h5>
          <button
            type="button"
            class="btn-close position-static"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body p-0">
          <form @submit.prevent="submitForm">
            <div class="contact-input-set">
              <div class="row">

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"> Layihə adı </label>
                    <input
                      v-model="formData.name"
                      class="form-control"
                      type="text"
                      name="name"
                      :class="{
                            'is-invalid': $v.formData.name.$error,
                            'is-valid': isSubmitForm && !$v.formData.name.$error,
                          }"
                    />
                  </div>
                  <template v-if="isSubmitForm && $v.formData.name.$error">
                      <p class="text-danger mt-1">Bu vacib məlumatdır</p>
                    </template>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">
                      Müştəri/Təchizatçı
                      <span class="text-danger">*</span>
                    </label>

                    <vue-select
                      :options="customersOptionsList"
                      name="customer_id"
                      :disabled="customersOptionsList.length == 0"
                      id="customerAdd"
                      v-model="formData.customer_id"
                      :placeholder="
                        customersOptionsList.length === 0
                          ? `Müştəri/Təchizatçı tapılmadı`
                          : ''
                      "
                      :class="{
                        'is-invalid': $v.formData.customer_id.$error,
                        'is-valid':
                          isSubmitForm && !$v.formData.customer_id.$error,
                      }"
                    />
                    <template
                      v-if="isSubmitForm && $v.formData.customer_id.$error"
                    >
                      <p class="text-danger mt-1">Bu vacib məlumatdır</p>
                    </template>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Tarixi <span class="text-danger">*</span></label
                    >
                    <div class="cal-icon">
                      <flat-pickr
                          :config="dateTime"
                          placeholder="il-ay-gün"
                          v-model="formData.date"
                          :class="{
                            'is-invalid': $v.formData.date.$error,
                            'is-valid': isSubmitForm && !$v.formData.date.$error,
                          }"
                          id="dateAdd" class="form-control">
                      </flat-pickr>
                    </div>
                    <template v-if="isSubmitForm && $v.formData.date.$error">
                      <p class="text-danger mt-1">Bu vacib məlumatdır</p>
                    </template>
                  </div>
                </div>
                
                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"> Qaimə nömrəsi </label>
                    <input
                      v-model="formData.invoice_number"
                      class="form-control"
                      type="text"
                      name="invoice_number"
                      :class="{
                        'is-valid': isSubmitForm,
                      }"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"> Qeyd </label>

                    <textarea
                      v-model="formData.note"
                      class="form-control"
                      type="text"
                      name="note"
                      :class="{
                        'is-valid': isSubmitForm,
                      }"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"> Əlavə qeyd </label>

                    <textarea
                      v-model="formData.additional_note"
                      class="form-control"
                      type="text"
                      name="note"
                      :class="{
                        'is-valid': isSubmitForm,
                      }"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <label class="col-form-label">Fayllar</label>
                  <FileUploadCustom v-model="files" :multiple="true" ref="dropzoneUpload"/>
                </div>

                <div>
                  <div>
                    <table class="table table-borderless table-auto">
                      <thead>
                        <tr>
                          <th>Məhsul <span class="text-danger">*</span></th>
                          <th>Miqdar <span class="text-danger">*</span></th>
                          <th>Məbləğ <span class="text-danger">*</span></th>
                          <th>
                            Ölçü vahidi <span class="text-danger">*</span>
                          </th>
                          <th class="mw-20r">Qeyd</th>
                          <th>Toplam</th>
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody class="service-items">
                        <tr
                          class="gap-3 mb-4"
                          v-for="(line, index) in formData.lines"
                          :key="index"
                        >
                          <td class="mw-15r">
                            <vue-select
                              :options="servicesOptionsList"
                              :disabled="servicesOptionsList.length == 0"
                              :id="`lineService${index}`"
                              v-model="line.service_id"
                              @update:modelValue="changeEventService($event,index)"
                              :placeholder="
                                servicesOptionsList.length > 0
                                  ? 'Məhsul seçin'
                                  : `Məhsul tapılmadı`
                              "
                            />
                          </td>
                          <td>
                            <input
                              class="form-control"
                              :id="`quantity${index}`"
                              v-model="line.quantity"
                              type="text"
                            />
                          </td>
                          <td>
                            <input
                              class="form-control"
                              :id="`price${index}`"
                              v-model="line.price"
                              type="text"
                            />
                          </td>
                          <td>
                            <vue-select
                              :options="props.measuresOptionsList"
                              :disabled="props.measuresOptionsList.length == 0"
                              :id="`lineUnit${index}`"
                              v-model="line.measure_id"
                              :placeholder="
                                props.measuresOptionsList.length > 0
                                  ? 'Seçin'
                                  : `Ölçü vahidi tapılmadı`
                              "
                            />
                          </td>
                          <td>
                            <input
                              class="form-control"
                              :id="`note${index}`"
                              v-model="line.note"
                              type="text"
                            />
                          </td>
                          <td>
                            <input
                              disabled
                              class="form-control"
                              :id="`total${index}`"
                              :value="line.price * line.quantity"
                              type="text"
                            />
                          </td>
                          <td>
                            <button
                              v-if="index > 0"
                              type="button"
                              @click="removeLine(index)"
                              class="btn btn-sm btn-outline-danger"
                            >
                              <i class="las la-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="mt-4">
                    <div>
                      <button
                        type="button"
                        @click="addLine"
                        class="btn btn-outline-success"
                      >
                        + Məhsul
                      </button>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end my-4">
                    Ümumi məbləğ: {{ calculatedTotalPrice }} azn
                  </div>
                </div>

                <div class="col-lg-12 text-end form-wizard-button">
                  <button class="button btn-lights reset-btn" type="reset">
                    Sıfırla
                  </button>
                  <button class="btn btn-primary" type="submit">
                    Yadda saxla
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script setup>
import { ref, defineEmits, reactive, watch, onMounted, computed } from "vue";
import {
  helpers,
  maxValue,
  minValue,
  required,
  decimal,
} from "@vuelidate/validators";
import FlatPickr from 'vue-flatpickr-component';
import { useFileUpload } from "@/stores/modules/fileUpload";
import { useVuelidate } from "@vuelidate/core";
import { showErrorToast, showSuccessToast, closeModal } from "@/utils/helper";
import { useCustomersAndSuppliers } from "@/stores/modules/customerAndSuppliers";
import { useServices } from "@/stores/modules/services";
import { useProjectStore } from "@/stores/modules/projects";
import FileUploadCustom from "@/components/file-upload-custom.vue";

const projectStore = useProjectStore();
const serviceStore = useServices();
const customerStore = useCustomersAndSuppliers();
const fileUplaodStore  = useFileUpload();


const dropzoneUpload = ref(null);
const files = ref([]);

const props = defineProps({
  measuresOptionsList: {
    type: Array,
    default: [],
  },
});

const customersOptionsList = ref([]);
const servicesOptionsList = ref([]);

const emit = defineEmits(["formSubmited", "close"]);
const isSubmitForm = ref(false);

const dateTime = ref({
    dateFormat: 'Y-m-d',
    allowInput: true,
    position: 'auto right'
});

const formData = reactive({
  name: null,
  invoice_number: null,
  note: null,
  additional_note: null,
  customer_id: 0,
  company_id: 0,
  date: new Date(),
  file_ids: [],
  lines: [
    {
      service_id: 0,
      quantity: null,
      price: null,
      note: null,
      measure_id: null,
    },
  ],
});

const rules = {
  formData: {
    name: { required },
    date: { required },
    customer_id: { required },
    // note: { required },
    lines: {
      $each: {
        service_id: { required },
        quantity: { required, minValue: minValue(1) },
        price: { required, minValue: minValue(0.01) },
        // note: { required }
      },
    },
  },
};

const isUnique = (value) => {
  const serviceIds = new Set();

  for (const line of formData.lines) {
    if (serviceIds.has(line.service_id)) {
      return false;
    }
    serviceIds.add(line.service_id);
  }

  return true;
};

const $v = useVuelidate(rules, { formData });

const resetValidation = () => {
  isSubmitForm.value = false;
  $v.value.formData.$reset();
};

const resetFormData = () => {
  customersOptionsList.value = [];

  formData.name = null;
  formData.company_id = 0;
  formData.contract_id = 0;
  formData.customer_id = 0;
  formData.invoice_number = null;
  formData.note = null;
  formData.additional_note = null;
  formData.date = new Date();
  formData.file_ids = [];
  files.value = [];
  dropzoneUpload.value.clearFiles();
  formData.lines = [
    {
      service_id: 0,
      quantity: null,
      price: null,
      note: null,
      measure_id: null,
    },
  ];
};

const submitForm = async () => {
  isSubmitForm.value = true;

  $v.value.formData.$touch();
  if ($v.value.formData.$invalid) {
    return false;
  }
  try {
    let uploadFiles = new FormData();

    files.value.forEach((item, index) => {
        uploadFiles.append(`files[${index}]`, item.file);
    });

    if (files.value.length > 0) {
        formData.file_ids = await fileUplaodStore.store(uploadFiles);
    }

    await projectStore.add(formData).then(async (response) => {
      resetFormData();
      showSuccessToast(response.data.message);
      resetValidation();
      emit("formSubmited", formData);
      closeModal("addDataModal");
    });
  } catch (error) {
    console.log(error);
  }
};

const addLine = () => {
  formData.lines.push({
    service_id: 0,
    quantity: null,
    price: null,
    note: null,
    measure_id: null,
  });
};

const removeLine = (index) => {
  formData.lines.splice(index, 1);
};


const createCustomerList = () => {
  const params = {
    limit: 10000,
  };

  customerStore.getList({ params }).then(()=>{
    customersOptionsList.value = customerStore.dataList.data.data.map(item => ({
      id: item.id,
      text: item.name,
    }));
  });
};

const createServicesList = async () => {
  const params = {
    limit: 10000,
  };

  await serviceStore.getList({ params });

  servicesOptionsList.value = serviceStore.dataServices.data.data.map(
    (item) => ({
      id: item.id,
      text: item.name,
    })
  );
};

const getDetailByService = async function (id, index) {
        await serviceStore.getDetail(id);
        formData.lines[index].quantity = 1;
        formData.lines[index].price = serviceStore.dataService.data.price;
        formData.lines[index].service_id = serviceStore.dataService.data.id;
        formData.lines[index].measure_id = serviceStore.dataService.data.measure?.id;
};

const changeEventService = function(id, index) {
    getDetailByService(id, index);
};

onMounted(() => {
    createCustomerList();
    createServicesList();
});


const calculatedTotalPrice = computed(() => {
  let totalPrice = 0;
  for (const line of formData.lines) {
    if (line.quantity !== null && line.price !== null) {
      totalPrice += line.quantity * line.price;
    }
  }
  return totalPrice;
});
</script>

<style>
.mw-15r {
  min-width: 12rem;
}

.mw-20r {
  min-width: 20rem;
}
</style>

  